import { routesModel } from '../router.consts.ts';
import { RoutesMap } from '../router.types.ts';
import { ErrorModalTypes, useBoundStore } from '@Store/index.ts';
import { router } from '@Routes/__root';

import { t } from 'i18next';
import { Icons } from '@Components/icon/Icon.tsx';


export const setCurrentPageIndex = useBoundStore.getState().onboardingSlice.setCurrentPageIndex;
const getObData = useBoundStore.getState().onboardingSlice.getOnboardingData;
const { setErrorModal } = useBoundStore.getState().errorSlice;

export const _getPageIndex = (pageId: RoutesMap): number => {
  const { navigationStack } = { ...getObData() };
  return navigationStack.findIndex((page) => page === pageId);
};

export const _handleUnAuthorized = (): void => {
  router.navigate({ to: routesModel[RoutesMap.WELCOME].path });
};

export const handleGenericError = () => {
  setErrorModal({
    error: '',
    modalProps: {
      title: t('enErrors:default.title'),
      content: t('enErrors:default.description'),
      icon: Icons.Oops,
      buttonText: t('enErrors:auth.button'),
      type: ErrorModalTypes.GENERAL,
    },
  });
  throw router.navigate({ to: routesModel[RoutesMap.WELCOME].path });
};